import { Container, Section, Title, HighlightTitle } from './styles';

export default function DownloadSection() {
  return (
    <Section>
      <Container>
        <HighlightTitle>Whitepaper</HighlightTitle>

        <Title>Free Download</Title>
      </Container>
    </Section>
  );
}
